export const DOCUMENT_KINDS = [
  { kind: "PHOTO_ID", label: "Photo ID", required: true },
  { kind: "PASSPORT", label: "Passport" },
  { kind: "ABN_PROOF", label: "ABN proof" },
  { kind: "BANK_PROOF", label: "Bank proof" },
];

const STATUS_TONE = { VERIFIED: "emerald", REJECTED: "rose", UPLOADED: "amber" };
const STATUS_LABEL = { VERIFIED: "Verified", REJECTED: "Rejected", UPLOADED: "Waiting for review" };

export const statusTone = (status) => STATUS_TONE[status] || "neutral";
export const statusLabel = (status) => STATUS_LABEL[status] || "Not uploaded";

/**
 * One row per document kind with its newest upload. The server lists newest first, and an older
 * rejected upload stays on record for the office, so only the newest decides what the partner sees.
 * A kind can be uploaded when nothing is on file or the newest was rejected, as the server enforces.
 */
export const documentRows = (documents = []) => {
  const newest = {};
  documents.forEach((document) => {
    if (!newest[document.kind]) newest[document.kind] = document;
  });
  const known = DOCUMENT_KINDS.map(({ kind, label, required }) => ({
    kind,
    label,
    required: Boolean(required),
    document: newest[kind] || null,
  }));
  const others = Object.values(newest)
    .filter((document) => !DOCUMENT_KINDS.some((entry) => entry.kind === document.kind))
    .map((document) => ({
      kind: document.kind,
      label: "Other document",
      required: false,
      document,
    }));
  return [...known, ...others].map((row) => ({
    ...row,
    canUpload: row.kind !== "OTHER" && (!row.document || row.document.status === "REJECTED"),
  }));
};
